var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 offset-3"},[_vm._v(" Ошибка, такой страницы нет! Вернитесь на "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("главную")]),_vm._v("! ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }